/*!
 * v-title v2.0.1
 * (c) 2019-2022 yujinpan
 * Released under the MIT License.
 */

import _classCallCheck from '@babel/runtime/helpers/esm/classCallCheck';
import _createClass from '@babel/runtime/helpers/esm/createClass';
import _defineProperty from '@babel/runtime/helpers/esm/defineProperty';

var TitleStore = /*#__PURE__*/function () {
  function TitleStore() {
    _classCallCheck(this, TitleStore);
  }

  _createClass(TitleStore, null, [{
    key: "get",
    value:
    /**
     * @type {{[p: string]: import('tippy.js').Instance}}
     */
    function get(el) {
      var id = el.getAttribute(TitleStore.idAttrName);
      return TitleStore.instances[id];
    }
  }, {
    key: "add",
    value: function add(el, instance) {
      var id = ++TitleStore.id;
      el.setAttribute(TitleStore.idAttrName, id);
      TitleStore.instances[id] = instance;
    }
  }, {
    key: "remove",
    value: function remove(el) {
      var id = el.getAttribute(TitleStore.idAttrName);
      id in TitleStore.instances && delete TitleStore.instances[id];
    }
  }]);

  return TitleStore;
}();

_defineProperty(TitleStore, "instances", {});

_defineProperty(TitleStore, "id", 0);

_defineProperty(TitleStore, "idAttrName", 'title-id');

export { TitleStore };
